const enum ActionType {
  POST_VOTE = 'POST_VOTE',
  POST_DELETE = 'POST_DELETE',
  POST_FLAG = 'POST_FLAG',
}

export default ActionType;
